// @ts-nocheck
import * as Types from '../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
import { ContextLoadAndSave_SelectedOptionFragmentDoc } from '../fragments/circularFragments.generated';
export type SummaryUtils_CheckoutConfigOptionGroupFragment = { __typename?: 'CheckoutConfigOptionGroup', id: string, step: Types.CheckoutConfigOptionGroupStep, isEnabled: boolean, showOnCustomerSummary: boolean, subStepNumber?: number | null | undefined, group: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, displayPackageOptionsAsSingleProduct?: boolean | null | undefined, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType } | null | undefined, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean, isExteriorScheme: boolean, isSpecLevel: boolean, isInteriorScheme: boolean } }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string, marketingName: string } | null | undefined }, options: Array<{ __typename?: 'CheckoutConfigPotentialOption', id: string, totalPriceInCents: number, option: { __typename?: 'ReadyPlanOption', id: string, name: string, code: string } }>, selectedOption?: { __typename?: 'CheckoutConfigPotentialOption', id: string, totalPriceInCents: number, option: { __typename?: 'ReadyPlanOption', id: string, name: string, code: string } } | null | undefined, parentGroup?: { __typename?: 'ReadyPlanOptionGroup', id: string } | null | undefined, childGroup?: { __typename?: 'ReadyPlanOptionGroup', id: string } | null | undefined };

export type SummaryPrint_CheckoutConfigOptionGroupFragment = { __typename?: 'CheckoutConfigOptionGroup', id: string, step: Types.CheckoutConfigOptionGroupStep, isEnabled: boolean, showOnCustomerSummary: boolean, subStepNumber?: number | null | undefined, selectedOption?: { __typename?: 'CheckoutConfigPotentialOption', id: string, totalPriceInCents: number, includedByRoot?: { __typename?: 'CheckoutConfigPotentialOption', id: string, option: { __typename?: 'ReadyPlanOption', id: string, name: string, code: string } } | null | undefined, option: { __typename?: 'ReadyPlanOption', id: string, name: string, code: string } } | null | undefined, group: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, displayPackageOptionsAsSingleProduct?: boolean | null | undefined, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType } | null | undefined, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean, isExteriorScheme: boolean, isSpecLevel: boolean, isInteriorScheme: boolean } }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string, marketingName: string } | null | undefined }, options: Array<{ __typename?: 'CheckoutConfigPotentialOption', id: string, totalPriceInCents: number, option: { __typename?: 'ReadyPlanOption', id: string, name: string, code: string } }>, parentGroup?: { __typename?: 'ReadyPlanOptionGroup', id: string } | null | undefined, childGroup?: { __typename?: 'ReadyPlanOptionGroup', id: string } | null | undefined };

export const SummaryUtils_CheckoutConfigOptionGroupFragmentDoc = gql`
    fragment SummaryUtils_CheckoutConfigOptionGroup on CheckoutConfigOptionGroup {
  id
  step
  isEnabled
  showOnCustomerSummary
  subStepNumber
  group {
    id
    name
    displayPackageOptionsAsSingleProduct
    personalizationType {
      code
    }
    group {
      id
      type {
        id
        isElevation
        isExteriorScheme
        isSpecLevel
        isInteriorScheme
      }
    }
    location {
      id
      name
    }
    readyPlanLocation {
      id
      marketingName
    }
  }
  options {
    id
    totalPriceInCents
    option {
      id
      name
      code
    }
  }
  selectedOption {
    ...ContextLoadAndSave_SelectedOption
  }
  parentGroup {
    id
  }
  childGroup {
    id
  }
}
    ${ContextLoadAndSave_SelectedOptionFragmentDoc}`;
export const SummaryPrint_CheckoutConfigOptionGroupFragmentDoc = gql`
    fragment SummaryPrint_CheckoutConfigOptionGroup on CheckoutConfigOptionGroup {
  ...SummaryUtils_CheckoutConfigOptionGroup
  selectedOption {
    id
    includedByRoot {
      id
      option {
        id
        name
        code
      }
    }
  }
}
    ${SummaryUtils_CheckoutConfigOptionGroupFragmentDoc}`;